module.exports = __webpack_public_path__ + "img/repayment-success-icon.6ea7df12.png";